export default __webpack_public_path__ + "static/media/005-bicycle.83c890a2.svg";